<div class="loader loader-1">
	<div class="loader-outter"></div>
	<div class="loader-inner"></div>
</div>
<ansyn-animated-ellipsis [text]="loaderText" [rtl]="rtl"></ansyn-animated-ellipsis>
